export type FailureDomain =
  | "crash"
  | "gps"
  | "camera"
  | "network"
  | "realtime"
  | "notification"
  | "media"
  | "storage";

export const DEVICE_FAILURE_ERROR_CODES = {
  GPS_PERMISSION_DENIED: "gps_permission_denied",
  GPS_TIMEOUT: "gps_timeout",
  GPS_UNAVAILABLE: "gps_unavailable",
  LOCATION_REQUIRED: "location_required",
  CAMERA_PERMISSION_DENIED: "camera_permission_denied",
  CAMERA_UNAVAILABLE: "camera_unavailable",
  CAMERA_CAPTURE_FAILED: "camera_capture_failed",
  CAMERA_FLASH_TORCH_FAILED: "camera_flash_torch_failed",
  FILE_PICK_FAILED: "file_pick_failed",
  FILE_PICK_CANCELLED: "file_pick_cancelled",
  PWA_KILLED_DURING_FILE_PICKER: "pwa_killed_during_file_picker",
  CONNECTION_LOST: "connection_lost",
  IMAGE_COMPRESS_FAILED: "image_compress_failed",
  MEDIA_UPLOAD_FAILED: "media_upload_failed",
  REALTIME_CONNECTION_FAILED: "realtime_connection_failed",
  BROADCASTING_AUTH_FAILED: "broadcasting_auth_failed",
  PUSH_PERMISSION_DENIED: "push_permission_denied",
  PUSH_SUBSCRIPTION_FAILED: "push_subscription_failed",
  UNHANDLED_REJECTION: "unhandled_rejection",
  SHIFT_START_FAILED: "shift_start_failed",
  SHIFT_END_FAILED: "shift_end_failed",
  BREAK_ACTION_FAILED: "break_action_failed",
} as const;

export type DeviceFailureErrorCode =
  (typeof DEVICE_FAILURE_ERROR_CODES)[keyof typeof DEVICE_FAILURE_ERROR_CODES];

export const ERROR_CODE_FAILURE_DOMAIN: Record<DeviceFailureErrorCode, FailureDomain> = {
  [DEVICE_FAILURE_ERROR_CODES.GPS_PERMISSION_DENIED]: "gps",
  [DEVICE_FAILURE_ERROR_CODES.GPS_TIMEOUT]: "gps",
  [DEVICE_FAILURE_ERROR_CODES.GPS_UNAVAILABLE]: "gps",
  [DEVICE_FAILURE_ERROR_CODES.LOCATION_REQUIRED]: "gps",
  [DEVICE_FAILURE_ERROR_CODES.CAMERA_PERMISSION_DENIED]: "camera",
  [DEVICE_FAILURE_ERROR_CODES.CAMERA_UNAVAILABLE]: "camera",
  [DEVICE_FAILURE_ERROR_CODES.CAMERA_CAPTURE_FAILED]: "camera",
  [DEVICE_FAILURE_ERROR_CODES.CAMERA_FLASH_TORCH_FAILED]: "camera",
  [DEVICE_FAILURE_ERROR_CODES.FILE_PICK_FAILED]: "camera",
  [DEVICE_FAILURE_ERROR_CODES.FILE_PICK_CANCELLED]: "camera",
  [DEVICE_FAILURE_ERROR_CODES.PWA_KILLED_DURING_FILE_PICKER]: "camera",
  [DEVICE_FAILURE_ERROR_CODES.CONNECTION_LOST]: "network",
  [DEVICE_FAILURE_ERROR_CODES.IMAGE_COMPRESS_FAILED]: "camera",
  [DEVICE_FAILURE_ERROR_CODES.MEDIA_UPLOAD_FAILED]: "media",
  [DEVICE_FAILURE_ERROR_CODES.REALTIME_CONNECTION_FAILED]: "realtime",
  [DEVICE_FAILURE_ERROR_CODES.BROADCASTING_AUTH_FAILED]: "realtime",
  [DEVICE_FAILURE_ERROR_CODES.PUSH_PERMISSION_DENIED]: "notification",
  [DEVICE_FAILURE_ERROR_CODES.PUSH_SUBSCRIPTION_FAILED]: "notification",
  [DEVICE_FAILURE_ERROR_CODES.UNHANDLED_REJECTION]: "crash",
  [DEVICE_FAILURE_ERROR_CODES.SHIFT_START_FAILED]: "network",
  [DEVICE_FAILURE_ERROR_CODES.SHIFT_END_FAILED]: "network",
  [DEVICE_FAILURE_ERROR_CODES.BREAK_ACTION_FAILED]: "network",
};
